import React, { FC, useMemo } from 'react';
import { EmptyAvatarVariantEnum } from '@sweatpals/shared';
import { Avatar, useTheme } from '@mui/material';
import { ReactComponent as SpFace1 } from '../assets/icons/sp-face1.svg';
import { ReactComponent as SpFace2 } from '../assets/icons/sp-face2.svg';
import { ReactComponent as SpFace3 } from '../assets/icons/sp-face3.svg';
import { SxProps } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { clsx } from '@sweatpals/react-ui-kit';

export interface EmptyAvatarComponentProps {
	variant: EmptyAvatarVariantEnum;
	sx?: SxProps<Theme>;
	iconSize?: string;
	alt?: string;
}

const EmptyAvatar: FC<EmptyAvatarComponentProps> = ({ variant, sx, alt, iconSize = '16px' }) => {
	const theme = useTheme();

	const iconColor = useMemo(() => {
		switch (variant) {
			case EmptyAvatarVariantEnum.Orange:
				return theme.palette.primary.main;
			case EmptyAvatarVariantEnum.Blue:
				return theme.palette.secondary.main;
			case EmptyAvatarVariantEnum.Yellow:
				return theme.palette.warning.main;
			default:
				return theme.palette.primary.main;
		}
	}, [variant, theme]);

	return (
		<Avatar
			alt={alt}
			sx={clsx(
				{
					borderRadius: '50%',
					height: '32px',
					width: '32px',
					background: iconColor,
					color: 'white',
					'& > img': {
						width: iconSize,
						height: iconSize,
						stroke: 'currentColor',
						fill: 'currentColor',
					},
				},
				sx
			)}
		>
			{variant === EmptyAvatarVariantEnum.Orange && <img src="/assets/icons/sp-face1.svg" alt="sp-face1" />}
			{variant === EmptyAvatarVariantEnum.Blue && <img src="/assets/icons/sp-face2.svg" alt="sp-face2" />}
			{variant === EmptyAvatarVariantEnum.Yellow && <img src="/assets/icons/sp-face3.svg" alt="sp-face3" />}
		</Avatar>
	);
};

export default EmptyAvatar;
